class CareersComponent extends HTMLElement {
  constructor() {
    super()

    this.querySelectorAll('.job-listing').forEach((listing) =>
      listing.addEventListener('click', this.onListingClick.bind(this))
    )
  }

  onListingClick(event) {
    if (event.currentTarget.classList.contains('active')) {
      event.currentTarget.classList.remove('active')
    } else {
      event.currentTarget.classList.add('active')
    }
  }
}

customElements.define('careers-component', CareersComponent)
